/**
 * How far back the dashboard opens.
 *
 * Three days, same as the legacy's `<Dashboard daysOffset={3} />`. It matters
 * more here than on other screens: this is where the user lands after logging
 * in, so the default window is paid on every session.
 */
export const DASHBOARD_DEFAULT_DAYS = 3;

/**
 * The channel prefix the backend publishes to when something moved.
 *
 * Declared silent in `notificationsConstants` so it never reaches the Centro de
 * Actividad — it fires on status changes, not on jobs the user started.
 */
export const DASHBOARD_CHANNEL = 'dashboard';

/**
 * The floor between two automatic refetches.
 *
 * The notice is throttled on the backend as well (one every ten seconds per
 * admin), so this is the second guard rather than the only one: a busy account
 * still costs at most two queries a minute per open tab, and a quiet one costs
 * nothing at all.
 */
export const DASHBOARD_MIN_REFETCH_MS = 30_000;

/**
 * Which of the four tones an activity entry gets, by delivery status.
 *
 * The mockup's own vocabulary: green for delivered, amber for anything moving,
 * red for a bad ending, blue for everything still waiting. A status missing
 * from here falls back to `info`, so a status added on the backend shows up
 * neutral instead of miscoloured.
 */
export const ACTIVITY_TONE_BY_STATUS = {
  delivered: 'success',
  in_transit: 'warning',
  in_cd: 'warning',
  dropped_at_hub: 'warning',
  received_at_hub: 'warning',
  on_the_way: 'warning',
  ready_for_pickup: 'warning',
  withdrawn: 'warning',
  failed: 'danger',
  returning: 'danger',
  returned: 'danger',
  damaged: 'danger',
  compensated: 'danger',
  cancelled: 'danger',
};

/**
 * The bar colours of the "por empresa" ranking.
 *
 * Companies have no inherent colour the way a status does, so these only need
 * to be told apart from each other.
 */
export const COMPANY_COLORS = [
  '#00d693', '#60a5fa', '#a78bfa', '#f59e0b',
  '#fb7185', '#34d399', '#818cf8', '#fbbf24',
];

/**
 * The floor for the chart area.
 *
 * The card itself no longer sets a height: it stretches to its grid row, which
 * is as tall as "Actividad Reciente" beside it, and the chart takes whatever is
 * left over. That is what stops the card from resizing when you switch tabs —
 * a fixed height would have to be guessed, and guessed again every time either
 * card's content changed.
 *
 * This is only here for the case where the neighbour is short.
 */
export const CHART_MIN_HEIGHT = 'min-h-[260px]';
